export default __webpack_public_path__ + "static/media/play-icon.cce4ae51.svg";